<template>
	<div class="product-category-set">
		<button
			class="btn product-category-set__category-add-btn"
			type="button"
			@click="addCategory"
		>
			카테고리 추가 +
		</button>
		<button
			type="button"
			class="btn product-category-set__keyword-init-button"
			v-text="'키워드 초기화'"
			@click="keywordCheckedListChange([])"
		/>
		<p class="product-category-set__category-noti">
			※ 리뷰 키워드는 '대표 설정' 된 카테고리를 기준으로 전시됩니다.
		</p>
		<ul class="product-category-set__set-list" v-if="selectedCategoryList">
			<li
				class="product-category-set__set-list__item"
				v-for="(item, idx) in selectedCategoryList"
				:key="idx"
			>
				<div
					:class="[
						'product-category-set__set-box',
						{ checked: idx === primarySecondCategoryIdx },
					]"
				>
					<label class="product-category-set__represent-btn">
						<input
							class="product-category-set__represent-btn__input"
							type="radio"
							:value="idx"
							v-model="primarySecondCategoryIdxModel"
						/>
						<i
							class="product-category-set__represent-btn__icon fa fa-check-circle-o"
							aria-hidden="true"
						></i>
						<br />
						<span class="product-category-set__represent-btn__text"
							>대표</span
						>
					</label>
					<CategorySelector
						class="product-category-set__category-selector"
						ref="categorySelector"
						@setCheckedKeywordList="setCheckedKeywordList"
						@change="categoryChange($event, idx)"
						@mounted="categorySelectorMount(idx)"
						:wrapWidth="700"
						wrapWidthUnit="px"
					/>
					<button
						class="btn-delete--only-icon product-category-set__delete-btn"
						type="button"
						@click="deleteCategory(idx)"
					></button>
					<CheckboxList
						v-if="
							Array.isArray(keywordList) &&
							Array.isArray(keywordList[idx]) &&
							keywordList[idx].length > 0
						"
						:value="productTagList"
						:checkboxList="keywordList[idx]"
						key-name="value"
						class="product-category-set__keyword-list"
						@input="keywordCheckedListChange($event)"
					/>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import CategorySelector from '@/components/product/CategorySelector.vue';
	import CheckboxList from '@/components/CheckboxList';

	export default {
		name: 'ProductCategorySet',
		components: { CategorySelector, CheckboxList },
		computed: {
			...mapState('ProductController', [
				'selectedCategoryList',
				'keywordList',
				'primarySecondCategoryIdx',
				'productTagList',
				'keywordCheckListOrigin',
			]),
			primarySecondCategoryIdxModel: {
				get() {
					return this.primarySecondCategoryIdx;
				},
				set(nv) {
					this.$store.commit('ProductController/stateChange', [
						{ key: 'primarySecondCategoryIdx', value: nv },
					]);
				},
			},
		},
		methods: {
			setCheckedKeywordList() {
				const keywordCheckListOrigin = this.keywordCheckListOrigin;
				if (
					!Array.isArray(keywordCheckListOrigin) ||
					keywordCheckListOrigin.length < 1
				)
					return;
				const keywordCheckedList = keywordCheckListOrigin.reduce(
					(acc, checkItemOrigin) => {
						const checkedId = checkItemOrigin.idKeyword;
						this.keywordList.forEach((keywords, idx) => {
							if (
								keywords &&
								keywords.some(
									keyword => keyword.id === checkedId
								)
							) {
								if (!Array.isArray(acc[idx])) acc[idx] = [];
								acc[idx].push(checkedId);
							}
						});
						return acc;
					},
					[]
				);
				this.$store.commit('ProductController/stateChange', [
					{ key: 'keywordCheckListOrigin', value: [] },
					{ key: 'keywordCheckedList', value: keywordCheckedList },
				]);
			},
			addCategory() {
				this.$store.commit('modal/toggleModal', {
					id: 'ProductCategoryAdd',
				});
			},
			deleteCategory(idx) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				this.$store.commit('toggleSpinner', true);
				this.$store.commit('ProductController/deleteCategory', {
					idx,
					commit: this.$store.commit,
				});
			},
			categoryChange(
				{
					category1,
					category2,
					category3,
					keywordList,
					nextCategoryDepth,
				},
				idx
			) {
				keywordList = Array.isArray(keywordList)
					? keywordList.map(item => {
							return {
								id: item.id || item.idKeyword,
								value: item.name || item.keywordText,
							};
						})
					: null;
				this.$store.commit('ProductController/categoryChange', {
					category1,
					category2,
					category3,
					keywordList,
					idx,
					nextCategoryDepth,
				});
			},
			keywordCheckedListChange(newList) {
				this.$store.commit(
					'ProductController/keywordCheckedListChange',
					newList
				);
			},
			categorySelectorMount(idx) {
				const category1 = this.selectedCategoryList[idx].category1;
				const category2 = this.selectedCategoryList[idx].category2;
				const category3 = this.selectedCategoryList[idx].category3;
				const keywordList = this.keywordList[idx];
				this.$refs.categorySelector[idx].setCategory({
					category1,
					category2,
					category3,
					keywordList,
				});
			},
		},
		watch: {
			selectedCategoryList(list) {
				if (!Array.isArray(list) || list.length < 1) return;
				if (list.length - 1 < this.primarySecondCategoryIdx) {
					this.$store.commit('ProductController/stateChange', [
						{
							key: 'primarySecondCategoryIdx',
							value: list.length - 1,
						},
					]);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-category-set {
		.product-category-set__category-add-btn {
			display: inline-block;
		}

		&__keyword-init-button {
			margin-left: 16px;
		}

		.product-category-set__category-noti {
			display: block;
			margin: 0 0 0 8px;
			line-height: 30px;
			color: $red;
			font-size: 0.875rem;
			font-weight: normal;
		}

		.product-category-set__set-list {
			margin-top: 18px;
		}

		.product-category-set__set-list__item {
			margin-top: 18px;
		}

		.product-category-set__set-box {
			position: relative;
			padding-left: 40px;

			&.checked {
				.product-category-set__represent-btn__icon,
				.product-category-set__represent-btn__text {
					color: $green;
				}
			}
		}

		.product-category-set__represent-btn {
			cursor: pointer;
			position: absolute;
			display: block;
			top: 0;
			left: 0;
			width: 40px;
			text-align: center;
			font-size: 0;
		}

		.product-category-set__represent-btn__input {
			display: none;
		}

		.product-category-set__represent-btn__icon,
		.product-category-set__represent-btn__text {
			cursor: pointer;
			display: inline-block;
			color: #333;
			font-weight: 700;
		}

		.product-category-set__represent-btn__icon {
			font-size: 20px;
		}

		.product-category-set__represent-btn__text {
			margin-top: 4px;
			font-size: 0.875rem;
		}

		.product-category-set__category-selector {
			vertical-align: top;
		}

		.product-category-set__delete-btn {
			display: inline-block;
			margin: 3px 0 0 8px;
			width: 30px;
			padding: 0;
		}

		.product-category-set__keyword-list {
			margin: 8px 0 0 0;
			padding: 8px;
			background: #f4f7fa;
			border: solid 1px #dfe6ee;
		}
	}
</style>
